// store/modules/search.js
const state = {
    searchModel: localStorage.getItem('searchData') ? JSON.parse(localStorage.getItem('searchData')).searchModel : '',
    searchBrand: localStorage.getItem('searchData') ? JSON.parse(localStorage.getItem('searchData')).searchBrand : '',
    searchChecked: localStorage.getItem('searchData') ? JSON.parse(localStorage.getItem('searchData')).searchChecked : false
}

const mutations = {
    SET_SEARCH_DATA(state, searchData) {
        state.searchModel = searchData.searchModel || ''
        state.searchBrand = searchData.searchBrand || ''
        state.searchChecked = searchData.searchChecked || false

        localStorage.setItem('searchData', JSON.stringify(searchData))
    },
    CLEAR_SEARCH_DATA(state) {
        state.searchModel = ''
        state.searchBrand = ''
        state.searchChecked = false
        localStorage.removeItem('searchData')
    }
}

const actions = {
    updateSearchData({ commit }, searchData) {
        commit('SET_SEARCH_DATA', searchData)
    },
    clearSearchData({ commit }) {
        commit('CLEAR_SEARCH_DATA')
    }
}

const getters = {
    searchData: (state) => {
        let searchData = JSON.parse(localStorage.getItem('searchData'))
        console.log(searchData,1)
        return {
            searchModel: state.searchModel ?? searchData?.searchModel,
            searchBrand: state.searchBrand ?? searchData?.searchBrand,
            searchChecked: state.searchChecked ?? searchData?.searchChecked
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
